var gql = require("@apollo/client").gql;

const TARIFF_TAGS_QUERY = gql`
	query TARIFF_TAGS_QUERY($filter: String, $removeId: [Int], $providerPage: Boolean) {
		tariffsTags(filter: $filter, removeId: $removeId, providerPage: $providerPage) {
			data {
				name
				url
				count
				filter
				internet {
					speedMin
					speedMax
				}
				tv {
					channelMin
					channelHdMin
					allChannelMin
					channelMax
					channelHdMax
					allChannelMax
				}
				mobile {
					internetMin
					internetMax
					countInternetType1
					smsMin
					smsMax
					countSmsType1
					callsMin
					callsMax
					countCallsType1
				}
				price {
					priceMin
					priceMax
				}
			}
		}
	}
`;

export default TARIFF_TAGS_QUERY;
